import styled from '@emotion/styled'
import { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import User from '../UserInfo'

const linkDefault = [
  { href: '/', label: '首页' },
  { href: '/teacher-welfare', label: '教师福利' },
  { href: '/problem', label: '常见问题' },
  { href: '/requirement', label: '设备要求' },
  { href: '/download', label: '下载中心' },
  { href: '/center', label: '个人中心', needLogin: true }
].map((link) => ({ ...link, key: `nav-link-${link.href}-${link.label}`, target: '' }))

export default function Index() {
  const [uid, setuid] = useState<string | null>(null)
  const [head, sethead] = useState<string | null>(null)
  const [username, setusername] = useState<string | null>(null)
  const [links, setlinks] = useState(linkDefault)
  const location = useLocation()

  useEffect(() => {
    const uid = localStorage.getItem('userid')
    const head = localStorage.getItem('head')
    const username = localStorage.getItem('username')
    if (uid) {
      setuid(uid)
      sethead(head)
      setusername(username)
    }
  }, [])

  return (
    <Container>
      <div className="center">
        <div className="logo">
          <NavLink to="/">
            <img src="https://imgvip.meishubao.com/teacher/img/logo.jpg" alt="" />
          </NavLink>
        </div>
        <div className="menu">
          <ul>
            {links.map(({ href, key, label, target, needLogin }, i) => {
              if (needLogin) {
                return (
                  uid && (
                    <li key={key}>
                      <NavLink to={href} className={href === location.pathname ? 'active' : ''}>
                        {label}
                      </NavLink>
                    </li>
                  )
                )
              } else {
                return (
                  <li key={key}>
                    <NavLink to={href} className={href === location.pathname ? 'active' : ''}>
                      {label}
                    </NavLink>
                  </li>
                )
              }
            })}
            {/* <li>
              <a onClick={this.logined.bind(this)}>个人中心</a>
            </li> */}
          </ul>
        </div>
        {uid && <User></User>}
      </div>
    </Container>
  )
}

const Container = styled.div`
  background-color: #fff;
  position: relative;
  z-index: 10;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 13px 0 10px;
  .center {
    width: 100%;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    .logo {
      img {
        height: 52px;
        width: 100px;
      }
    }

    .menu {
      flex: 1;
      min-width: 500px;
      ul {
        list-style-type: none;
        display: flex;
        padding-left: 50px;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;

        li {
          margin: 0 20px;
          a {
            position: relative;
            text-decoration: none;
            color: #4d4d4d;
            cursor: pointer;
            &:hover:after {
              content: '';
              border: 1px solid #ff3300;
              position: absolute;
              width: 100%;
              left: -2px;
              bottom: -15px;
            }
          }
          a.active,
          a:hover {
            font-weight: 800;
            &:after {
              content: '';
              border: 1px solid #f30;
              position: absolute;
              width: 24px;
              left: 50%;
              bottom: -9px;
              transform: translateX(-50%);
            }
          }
        }
      }
    }

    .login {
      display: flex;
      cursor: pointer;
      padding: 6px 0;
      box-sizing: border-box;
      position: relative;
      .username {
        line-height: 40px;
        font-size: 14px;
        display: block;
        font-weight: 300;
        margin-right: 8px;
      }

      .head-avatar {
        height: 44px;
        width: 44px;
        border-radius: 44px;
      }

      .context-menu {
        display: none;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 0px 0px 4px 4px;
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
        width: 150px;
        text-align: center;
        ul {
          list-style-type: none;
          margin: 0;
          padding: 0;
          user-select: none;
          li {
            font-size: 16px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(77, 77, 77, 1);
            line-height: 27px;
            padding: 5px 15px;
            &:hover {
              background: rgba(245, 245, 245, 1);
              box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
              border-radius: 0px 0px 4px 4px;
              color: black;
            }
          }
        }
      }

      &:hover {
        .context-menu {
          display: block;
        }
      }
    }
  }
`
